import { render, staticRenderFns } from "./ViewCurso.vue?vue&type=template&id=5c2d61f8&scoped=true&"
import script from "./ViewCurso.vue?vue&type=script&lang=js&"
export * from "./ViewCurso.vue?vue&type=script&lang=js&"
import style0 from "./ViewCurso.vue?vue&type=style&index=0&id=5c2d61f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d61f8",
  null
  
)

export default component.exports